import { Box, Divider, Grid } from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import TemplateOpcoes from "../../Templates/TemplateOpcoes"
import AddIcon from '@mui/icons-material/Add';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import { useNavigate } from "react-router-dom";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import { usePermission } from "../../../PermissionGuard";

export default function FiscalMenu({ type }: MenusProps) {

    const navigate = useNavigate();
    const { handleToggleModal } = useModalStateContext();

    const color = colors[type] || "#1E2E6B"
    const textColor = escurecerCor(color)

    const handleRedirect = (path: string) => {
        navigate(`/fiscal/${path}`)
    }

    return (
        <Box>
            <Grid container spacing={2}>

                <TemplateDashboardComOpcoes
                    {...{ type }}
                    color={textColor}
                    items={[]}
                />

                <Divider orientation="vertical" sx={{ border: '1px solid', borderColor: 'divider', }} flexItem />

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Notas Fiscais"
                        color={textColor}
                        items={[
                            {
                                label: "Listar todas",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("notas-fiscais/listar-todas"),
                                disabled: !usePermission("fiscal.notas-fiscais.listar-todas")
                            }
                        ]}
                    />
                </Grid>

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">

                </Grid>

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">

                </Grid>
            </Grid>
        </Box>
    )
}

